var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM14.4429 25.368C15.8109 26.544 17.6109 27.288 20.0109 27.288C23.7549 27.288 26.0589 24.96 26.0589 21.792V21.744C26.0589 18.624 23.8269 17.424 21.5469 17.04L24.8349 13.896C25.5069 13.248 25.9389 12.744 25.9389 11.832C25.9389 10.824 25.1469 10.2 24.0669 10.2H15.8829C15.0189 10.2 14.2989 10.92 14.2989 11.784C14.2989 12.648 15.0189 13.368 15.8829 13.368H21.0429L17.7789 16.656C17.2029 17.232 16.9869 17.664 16.9869 18.168C16.9869 19.032 17.7069 19.752 18.5709 19.752H19.1469C21.2109 19.752 22.4349 20.52 22.4349 21.888V21.936C22.4349 23.184 21.4509 23.976 20.0589 23.976C18.7389 23.976 17.7309 23.544 16.7709 22.728C16.4829 22.488 16.1229 22.272 15.5949 22.272C14.6349 22.272 13.8189 23.088 13.8189 24.048C13.8189 24.576 14.1069 25.08 14.4429 25.368Z",
    fill: "#4A22D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step3.eb43b20c2159b23067a4a72544f7066a.svg";
export { ForwardRef as ReactComponent };